import React from 'react';
import "../../css/slider.css";

const mainLandMark = (props) => (
    <div className="slider-container3">
    </div>
    );

export default mainLandMark;